import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import RoundScreen from '../../../components/roundScreen';
import MultiHalfText from '../../../components/MultiHalfText';

export default function Page21({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<MultiHalfText first='HIIT / Plyometrics' second='Workout 04' mt={true} />
			<RoundScreen
				isNumbered={false}
				rounds={[
					[
						{
							header: 'FULLBODY / HIT',
							value: 'Squat Jumps',
						},
						{
							header: 'REPS',
							value: '10',
						},
					],
					[
						{
							header: 'FULLBODY / HIT',
							value: 'Goblet Squats w / DB (optional)',
						},
						{
							header: 'REPS',
							value: '15',
						},
					],
					[
						{
							header: 'FULLBODY / HIT',
							value: 'Split Lunges w / DB',
						},
						{
							header: 'REPS',
							value: '12',
						},
					],
					[
						{
							header: 'FULLBODY / HIT',
							value: 'Laterals w / DB',
						},
						{
							header: 'REPS',
							value: '10',
						},
					],
					[
						{
							header: 'FULLBODY / HIT',
							value: 'Burpees',
						},
						{
							header: 'REPS',
							value: '8',
						},
					],
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
